module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_6000.af548f95.png";